import React from "react";
import { XIcon } from "lucide-react";
import { pains } from "../data/pains";
export function PainSection() {
  return <section className="bg-ebony py-20 md:py-28" aria-labelledby="pain-title" data-id="element-184" data-mp="38wlu0t2p6shq">
      <div className="mx-auto grid max-w-6xl gap-12 px-5 lg:grid-cols-2 lg:gap-20" data-id="element-185" data-mp="2uyx8dj0t3hbm">
        <div data-id="element-186" data-mp="2yzh7ut8uqx0x">
          <h2 id="pain-title" className="font-display text-4xl uppercase leading-none text-linen md:text-6xl" data-id="element-187" data-mp="2yyzaftagecrf">
            Ça vous <span className="text-brass" data-id="element-188" data-mp="2l6j3iheflul8">parle</span> ?
          </h2>
          <p className="mt-6 max-w-md font-serif text-lg italic text-sand/80" data-id="element-189" data-mp="2q0nbn3zfo8nw">
            Enseigner le piano, c'est magnifique. Tout organiser seul, beaucoup moins.
          </p>
          <img src="https://cdn.magicpatterns.com/patterns/generated-images/5876e1a7-04b0-42b8-a907-073f6e51e7b2.jpg" alt="Professeure guidant la main d'un élève sur le clavier" className="mt-10 hidden aspect-[3/2] w-full rounded-2xl border-4 border-walnut object-cover lg:block" data-id="element-190" data-mp="2gaauzmuqozn1" />
        </div>
        <ul className="self-center divide-y divide-linen/10" data-id="element-191" data-mp="3rp3s8s7cztmz">
          {pains.map(pain => <li key={pain} className="flex gap-5 py-6 first:pt-0" data-id="element-192" data-mp="3nniaasfywp5x">
              <span className="mt-1 flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-walnut" data-id="element-193" data-mp="5ehqqzedc9ry">
                <XIcon className="h-3.5 w-3.5 text-brass" aria-hidden="true" data-id="element-194" data-mp="h94onq3nllf" />
              </span>
              <p className="text-lg leading-relaxed text-linen" data-id="element-195" data-mp="38x2kt1giqv1y">{pain}</p>
            </li>)}
          <li className="pt-8" data-id="element-196" data-mp="33z11cff6ktpy">
            <p className="font-serif text-xl text-brass" data-id="element-197" data-mp="3imce2kn3mjrn">
              Si vous vous êtes reconnu, ce pack a été conçu pour vous.
            </p>
          </li>
        </ul>
      </div>
    </section>;
}